'use client'

import { MotionConfig } from 'framer-motion'

/**
 * App-wide framer-motion defaults: honour the OS "reduce motion" setting (transforms and
 * layout animations are skipped, opacity still fades) and give every transition that does not
 * set its own the shell's ease-out curve.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <MotionConfig reducedMotion="user" transition={{ duration: 0.24, ease: [0.23, 1, 0.32, 1] }}>
      {children}
    </MotionConfig>
  )
}
